module.exports = __webpack_public_path__ + "img/fancy_apartment.ba85fb56.svg";